'use strict';

// --------------------------------------------------------------------
// Imports
// --------------------------------------------------------------------

const Grammar = require('./Grammar');

// --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------

Grammar.BuiltInRules = require('../dist/built-in-rules');
